<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
    </div>
    <div class="global-table-container">
      <a-form
        layout="horizontal"
        :form="form"
        @submit="handleSubmit"
      >
        <a-form-item
          label="配置标识"
          :label-col="{span:5}"
          :wrapper-col="{span:10}"
        >
          <a-input
            v-decorator="[
              'flag',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入配置标识，(字母+下划线)',
                  },
                ],
                initialValue: data.flag
              },
            ]"
            placeholder="请输入配置标识，(字母+下划线)"
            :disabled="disabled"
          />
        </a-form-item>
        <a-form-item
          label="配置名称"
          :label-col="{span:5}"
          :wrapper-col="{span:10}"
        >
          <a-input
            v-decorator="[
              'label',
              {
                rules: [
                  {
                    required: true,
                    message: '请输入配置名称,（中文、字母、数字）',
                  },
                ],
                initialValue: data.label
              },
            ]"
            placeholder="请输入配置名称,（中文、字母、数字）"
            :disabled="disabled"
          />
        </a-form-item>
        <a-form-item
          label="排序"
          :label-col="{span:5}"
          :wrapper-col="{span:10}"
        >
          <a-input-number
            v-decorator="[
              'sort',
              { rules: [{ required: true, message: '请输入排序' }],
                initialValue: data.sort },
            ]"
            :disabled="disabled"
          />
        </a-form-item>
        <a-form-item
          v-for="(item,index) in data.value"
          :key="item.uuid"
          label="配置项集合"
          :label-col="{span:5}"
          :wrapper-col="{span:10}"
        >
          <a-input
            v-decorator="[
              `${item.uuid}.key`,
              {
                rules: [
                  {
                    required: true,
                    message: 'key值',

                  },
                ],
                initialValue: item.key
              },
            ]"
            placeholder="key值"
            style="width: 40%; margin-right: 8px"
            :disabled="disabled"
          />
          <a-input
            v-decorator="[
              `${item.uuid}.value`,
              {
                rules: [
                  {
                    required: true,
                    message: 'value值',
                  },
                ],
                initialValue: item.name||item.value
              },
            ]"
            placeholder="value值"
            style="width: 40%; margin-right: 8px"
            :disabled="disabled"
          />
          <a-icon
            v-if="data.value.length > 1 &&!disabled"
            class="dynamic-delete-button"
            type="minus-circle-o"
            :disabled="data.value.length === 1 "
            @click="() => remove(index)"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{span:10,offset:5}">
          <a-button
            v-if="!disabled"
            type="dashed"
            style="width: 60%"
            @click="add"
          >
            <a-icon type="plus" /> 增加项
          </a-button>
        </a-form-item>
        <a-form-item :wrapper-col="{span:10,offset:5}">
          <a-button
            style="margin-right:20px;"
            @click="onCancel"
          >
            返回
          </a-button>
          <a-button
            :loading="btnIsLoading"
            type="primary"
            html-type="submit"
            :disabled="disabled"
          >
            提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
const uuidv1 = require('uuid/v1');
export default {
  data(){
    return {
      btnIsLoading: false,
      data: {
        flag: '',
        label: '',
        sort: '',
        value: [{uuid: uuidv1(), key: '', value: ''}],
      },
      disabled: false,
      id: '',
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);

  },
  mounted(){
    // 查看
    if(this.$route.query&&this.$route.query.disabled==='true'){
      this.disabled=true;
    }

    if(this.$route.query&&this.$route.query.id){
      let id=this.$route.query.id;
      this.getDetails(id);
    }
  },
  methods: {
    // 回显
    async getDetails(id){
      let result = await this.$http.post(
        '/TypeAndConfig/info',
        {id},
      );
      if (result.data.status === 1) {
        let res=result.data.data;
        this.data={
          flag: res.flag,
          label: res.label,
          sort: res.sort,
          value: res.value.map((item)=>{
            item.uuid=uuidv1();
            return item;
          }),
        };
        console.log('this.data', this.data);
      }
    },
    remove(key){
      this.data.value = this.data.value.filter((item, index)=>index !== key);
    },
    add(){
      this.data.value.push({uuid: uuidv1(), key: '', value: ''});
    },
    handleSubmit(e) {

      e.preventDefault();
      this.form.validateFields(async(err, values) => {
        console.log('TCL: handleSubmit -> values', values);
        let value=[];
        Object.values(values).forEach((item)=>{
          if(typeof item ==='object'){
            value.push(item);
          }
        });
        values.value=value;
        if (!err) {
          this.btnIsLoading=true;
          if(this.$route.query&&this.$route.query.disabled==='false'){
            this.id=this.$route.query.id;
          }
          let data={
            id: this.id?this.id:undefined,
            flag: values.flag,
            label: values.label,
            sort: values.sort,
            value: values.value,
          };
          let result = await this.$http.post(
            '/TypeAndConfig/update',
            data,
          );
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');
            this.$router.back();
          }
        }
      });
    },
    // 返回
    onCancel(){
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>